import React from 'react';

type ActivityMode = 'visible' | 'hidden';

interface ActivityBoundaryProps {
  mode?: ActivityMode;
  children?: React.ReactNode;
}

export const ActivityBoundary: React.FC<ActivityBoundaryProps> = ({ mode, children }) => {
  // Attempt to use React.Activity if available, otherwise just render children
  const ActivityComponent = (React as any).Activity ?? React.Fragment; // Fallback to Fragment if Activity is not found
  return <ActivityComponent mode={mode}>{children}</ActivityComponent>;
};
